var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-perfect-scrollbar',{staticStyle:{"height":"90vh","width":"100%"}},[_c('div',{attrs:{"id":"changelog"}})])}
var staticRenderFns = []

export { render, staticRenderFns }